import type { LinkProps as AriaLinkProps } from 'react-aria-components'
import { Link as AriaLink, composeRenderProps } from 'react-aria-components'
import { focusRing } from '~/design-system/helpers'
import tv from '~/lib/tv'

export interface LinkProps extends AriaLinkProps {
  variant?: 'primary' | 'secondary' | 'disabled'
}

const linkVariants = tv({
  extend: focusRing,
  base: 'flex justify-end items-center gap-1 text-sm underline cursor-pointer hover:no-underline',
  variants: {
    variant: {
      primary: 'text-primary-orange',
      secondary: 'text-gray-700',
      disabled: 'text-gray-60 cursor cursor-default',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
})

export default function Link(props: LinkProps) {
  return (
    <AriaLink
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        linkVariants({ ...renderProps, className, variant: props.variant }),
      )}
      isDisabled={props.isDisabled}
    ></AriaLink>
  )
}
